import { useContext, useEffect } from "react";
import { MetadataContext } from "@/providers/MetadataProvider";
import { env } from "@/config/envvars";

export function useMetadata({ title, description }: { title: string; description: string }) {
  const setMetadata = useContext(MetadataContext);

  useEffect(() => {
    if (setMetadata) {
      const fullTitle = title.includes(env.APP_NAME)
        ? title
        : `${title} - ${env.APP_NAME}`;
      setMetadata({ title: fullTitle, description });
    }
    return () => {
      if (setMetadata) {
        setMetadata({ title: env.APP_NAME, description: "Mohtawa Creative OS" });
      }
    };
  }, [title, description, setMetadata]);

  return { setMetadata };
}